import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Select from '../../../form/component/Select'
import LabelInput from '../../../form/component/LabelInput'
import ContentBox from '../../../layout/component/ContentBox'
import { getProcessSelectList, getStateSelectList } from '../../state/helper'
import { renderStateName } from '../../../process/util/names'

const FunnelStep = ({ funnelStep, processStateNameList, funnelStepIndex, changeFunnelStep }) => {
    const processNameSelectList = getProcessSelectList(processStateNameList)
    const stateList = getStateSelectList(processStateNameList, funnelStep.processName)
    return (
        <Column size={2}>
            <LabelInput label="Process">
                <Select object={funnelStep} name="processName" addEmpty={!funnelStep.processName}
                    valueList={processNameSelectList}
                    onChange={(name, value) => {
                        changeFunnelStep(funnelStepIndex, name, value)
                    }}/>
            </LabelInput>
            <LabelInput label="State">
                <Select object={funnelStep}
                    name="stateName"
                    addEmpty={!funnelStep.stateName}
                    valueList={stateList}
                    renderer={(stateName) => {
                        return renderStateName(stateName.value)
                    }}
                    onChange={(name, value) => {
                        changeFunnelStep(funnelStepIndex, name, value)
                    }}/>
            </LabelInput>
            <div className="text-center">
                <h1 className="funnel-builder-cohort-total">{funnelStep.total}</h1>
            </div>
            <div className="text-center">
                {funnelStep.data && (<div>
                    {Object.keys(funnelStep.data).map((value, key) => {
                        return <span key={key}>{value} : {funnelStep.data[value]}<br/></span>
                    })}
                </div>)}
            </div>
        </Column>
    )
}


const FunnelStepList = (props) => {
    const { enrichedFunnelList } = props

    const funnelStepLength = enrichedFunnelList.length
    const outerLength = ((funnelStepLength - (funnelStepLength % 6)) / 6) + 1

    const rowColList = []

    for (let rowIndex = 0; rowIndex < outerLength; rowIndex++) {
        const columnList = []
        for (let columnIndex = 0; columnIndex < 6; columnIndex++) {
            const index = (rowIndex * 6) + columnIndex
            const funnelStep = enrichedFunnelList[index]
            if (funnelStep) {
                columnList.push(funnelStep)
            }
        }
        rowColList.push(columnList)
    }


    return (
        <ContentBox title="Funnel Steps">
            {rowColList.map((columnList, outerIndex) => {
                return (
                    <Row top="M" key={outerIndex}>
                        {
                            columnList.map((funnelStep, innerIndex) => {
                                const index = (outerIndex * 6) + innerIndex
                                return (<FunnelStep
                                    key={innerIndex}
                                    funnelStepIndex={index}
                                    funnelStep={funnelStep}
                                    {...props}/>)
                            })
                        }
                    </Row>
                )
            })}
        </ContentBox>
    )
}

FunnelStepList.propTypes = {
    enrichedFunnelList: PropTypes.array.isRequired,
    processStateNameList: PropTypes.object.isRequired,
    changeFunnelStep: PropTypes.func.isRequired,
}

export default FunnelStepList



// WEBPACK FOOTER //
// ./src/modules/analytics/component/funnel-builder/FunnelStepList.js